import { jsx } from "panel";
import { formatText } from "common/util/format-text";
import { TruncatedStatus } from "./types";
export function template() {
  const getControls = () => {
    switch (this.state.status) {
      case TruncatedStatus.None:
      case TruncatedStatus.Unknown:
        return null;
      case TruncatedStatus.Expanded:
        return /* @__PURE__ */ jsx("button", {
          attrs: { type: `button` },
          on: { click: this.helpers.toggleExpandStatus }
        }, "less");
      case TruncatedStatus.Collapsed:
        return /* @__PURE__ */ jsx("button", {
          attrs: { type: `button` },
          on: { click: this.helpers.toggleExpandStatus }
        }, "more");
    }
  };
  return /* @__PURE__ */ jsx("div", {
    sel: ".truncated-text-wrapper",
    class: {
      collapsed: this.state.status === TruncatedStatus.Collapsed,
      expanded: this.state.status === TruncatedStatus.Expanded,
      "no-truncation": this.state.status === TruncatedStatus.None,
      unknown: this.state.status === TruncatedStatus.Unknown
    },
    on: {
      click: [TruncatedStatus.Collapsed, TruncatedStatus.Expanded].includes(this.state.status) && this.helpers.maybeToggleExpandStatus
    }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".text",
    style: { "--clampLineCount": this.attr(`lines`).toString() },
    hook: {
      insert: (node) => this.helpers.setElmRef(node.elm)
    }
  }, formatText(this.attr(`text`))), getControls());
}
